export default "__VITE_ASSET__BaXDr78x__"